import Constant from "./Constant"
import Network from "./Network"
import UIManager from "./UIManager"
import { Global } from "./Global"
import Player from "../Models/Player"
import AddressManager from "./AddressManager";

class NetworkLogic {
    private _failedRequestsParams = []

    // 构造请求参数
    private makeParams (url: string, method: string, data: Object, cbSuccess?: Function, cbFail?: Function, ignoreEncryption?: boolean, requestHeader?: Object) {
        let params = {
            url: url,
            method: method,
            data: data,
            ignoreEncryption: ignoreEncryption,
            requestHeader: requestHeader,

            cb: function (err, response, requestParams) {
                if (!!err){
                    if (err === "请求失败") {
                    }else if (err === "网络错误") {
                    }else if (err === "请求超时") {
                    }

                    // 大佬要求不要强制弹窗，故这里先屏蔽掉改功能
                    // this._failedRequestsParams.push(requestParams)
                    // UIManager.showChangeDomainUI(function () {
                    //     this.reHttpRequest()
                    // }.bind(this))

                    UIManager.hideLoadingUI()
                    cbFail && cbFail()
                }else{
                    if (response.code !== "200"){
                        UIManager.hideLoadingUI()
                        
                        // msg为字符串信息，则显示
                        if (response.msg) {
                            try {
                                JSON.parse(response.msg)
                            }catch(e) {
                                UIManager.showToastUI(response.msg, Global.ToastType.Warnning)
                            }
                        }

                        if (response.code === "10086" || response.code === "9002") {
                            // 被挤下线，拦截
                            Player.logout()
                            !response.msg && UIManager.showToastUI("登录已失效，请重新登录", Global.ToastType.Warnning)
                        }else if (response.code === "10092") {
                            // 系统维护，拦截
                            cc.director.emit(Global.UserEvent.OpenMantain);
                            let data = JSON.parse(response.msg)
                            UIManager.showConfirmUI(data.explainTxt, function () {
                                cc.sys.openURL(data.address)
                            }, "在线客服", function () {

                            }, "退出游戏")
                        }else {
                            // 服务器返回错误
                            cbFail && cbFail(response)
                        }
                    }else{
                        cbSuccess && cbSuccess(response.data)
                    }
                }
            }.bind(this)
        }

        return params
    }
    
    // 普通http请求
    private httpRequest (url: string, method: string, data: Object, cbSuccess?: Function, cbFail?: Function, ignoreEncryption?: boolean, requestHeader?: Object) {
        let params = this.makeParams(url, method, data, cbSuccess, cbFail, ignoreEncryption, requestHeader)
        Network.httpRequest(params)
    }

    // 重新连接失败的请求
    private reHttpRequest () {
        if (this._failedRequestsParams) {
            this._failedRequestsParams.forEach(params => {
                // 可能线路已经切换，故需要替换域名
                let newDomain = AddressManager.getServerDomain()
                if (newDomain && params.url.indexOf(newDomain) === -1) {
                    params.url = params.url.replace(/(http|https):\/\/(.*?)\//g, newDomain + "/");
                }
                Network.httpRequest(params)
            });
        }
        this._failedRequestsParams = []
    }

    // 上传文件http请求
    private uploadHttpRequest (url: string, method: string, data: Object, cbSuccess?: Function, cbFail?: Function) {
        let params = this.makeParams(url, method, data, cbSuccess, cbFail, true)
        Network.uploadRequest(params);
    }

    // 游戏服
    private gameServerHttpRequest (route: string, method: string, data: Object, cbSuccess?: Function, cbFail?: Function, ignoreEncryption?: boolean, requestHeader?: Object) {
        let url = AddressManager.getServerAdress() + route
        this.httpRequest(url, method, data, cbSuccess, cbFail, ignoreEncryption, requestHeader)
    }

    // 活动服
    private activityServerHttpRequest (route: string, method: string, data: Object, cbSuccess?: Function, cbFail?: Function, ignoreEncryption?: boolean, requestHeader?: Object) {
        let url = AddressManager.getActivityAddress() + route
        this.httpRequest(url, method, data, cbSuccess, cbFail, ignoreEncryption, requestHeader)
    }

    // 参数转拼接字符串
    private getParamsStr (data: Object) {
        let str = "?"

        for (let key in data){
            if (data.hasOwnProperty(key)){
                if (str !== "?"){
                    str += "&";
                }
                str += (key + "=" + data[key]);
            }
        }

        return str
    }

    /**
     * 上传文件
     * @param fileName 文件名
     * @param fileData 文件数据
     * @param cbSuccess 
     * @param cbFail 
     * @example
     * NetworkLogic.uploadFile("xx.png", jsb.fileUtils.getDataFromFile(jsb.fileUtils.fullPathForFilename("xx.png")))
     */
    uploadFile(fileName, fileData, cbSuccess?, cbFail?){//上传图片
        let url = AddressManager.getServerAdress() + "/api/upload";
        let requestData = {
            "fileName": fileName,
            "fileData": fileData
        }
        this.uploadHttpRequest(url, 'POST', requestData, cbSuccess, cbFail);
    }

    // 获取配置
    getConfigValue(type, cbSuccess?, cbFail?) {
        let route = "/api/conf/getValue" + this.getParamsStr({type: type})
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    // 获取OSS地址
    //http://test1.subo365.cc/imsbase/api/conf/getConfig?type=apiOssDomain&label=url
    getOssAddr( cbSuccess?, cbFail?) {
        let route = "/api/conf/getConfig?type=apiOssDomain&label=url"
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }


    userLoginConfig (cbSuccess?, cbFail?) {
        let route = "/api/user/userLoginConfig"
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    // userLoginList (cbSuccess?, cbFail?) {//注册配置
    //     let route = "/user/userregisterconfig/list"
    //     this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    // }

    userGetVisitorBindingStatus (data,cbSuccess?, cbFail?) {
        let route = "/api/user/getVisitorBindingStatus"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    userVisitorBindingDevice (data,cbSuccess?, cbFail?) {
        let route = "/api/user/visitorBindingDevice"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    userVisitorUntieDevice (data,cbSuccess?, cbFail?) {
        let route = "/api/user/visitorUntieDevice"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    loginVisitorCreate (cbSuccess?, cbFail?) {
        let route = "/api/user/visitorCreate"
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    loginVisitorVerification (data,cbSuccess?, cbFail?) {
        let route = "/api/user/visitorVerification"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    loginVisitorRegistered (data,cbSuccess?, cbFail?) {
        let route = "/api/user/visitorRegistered"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    loginVisitorEditData (data,cbSuccess?, cbFail?) {//完善资料
        let route = "/api/user/visitorEditData"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }




    phoneCode (phone: string, cbSuccess?, cbFail?) {
        let route = "/api/user/sms" + this.getParamsStr({phone: phone})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'GET', requestData, cbSuccess, cbFail)
    }

    register (data, cbSuccess?, cbFail?) {
        let route = "/api/user/register"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    login (data, cbSuccess?, cbFail?) {
        let route = "/api/user/login"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    loginRecord (cbSuccess?, cbFail?) {
        let route = "/api/user/loginRecord"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    userInfo (data, cbSuccess?, cbFail?) {
        let route = "/api/user/userInfo"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    editPersonalInfo (data, cbSuccess?, cbFail?) {
        let route = "/api/user/editPersonalInfo"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    editPassword (oldPassword, newPassword, cbSuccess?, cbFail?) {
        let route = "/api/user/editPassword"
        let requestData = {
            "userPwd": oldPassword,
            "newUserPwd": newPassword,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    logout (cbSuccess?, cbFail?) {
        let route = "/api/user/logout"
        this.gameServerHttpRequest(route, 'POST', null, cbSuccess, cbFail)
    }

    findAmount(cbSuccess?, cbFail?) {
        let route = "/api/user/findAmount"
        this.gameServerHttpRequest(route, 'POST', null, cbSuccess, cbFail)
    }

    getGameList (parent, cbSuccess?, cbFail?) {
        let route = "/api/home/getGameList" + (parent ? this.getParamsStr({parent: parent}) : "")
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail, null, {templateId: cc.sys.localStorage.getItem("TemplateID")})
    }


    // 获取首页图片和网址
    getHomeLogo(cbSuccess?, cbFail?) {
        let route = "/api/site/logo/findById"
        this.gameServerHttpRequest(route, 'POST', null, cbSuccess, cbFail)
    }

    siteGlobal(cbSuccess?, cbFail?) {
        let route = "/api/siteGlobal"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    hotPlusGames (gameType, cbSuccess?, cbFail?) {
        let route = "/api/home/hotPlusGames" + this.getParamsStr({gameType: gameType})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail, null, {templateId: cc.sys.localStorage.getItem("TemplateID")})
    }

    enterThirdGame (id, gameListId, cbSuccess?, cbFail?) {
        let route = "/api/thirdGames/forwardGame"
        let requestData = {
            "id": id,
            "gameListId": gameListId,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    lowerScore (flag, cbSuccess?, cbFail?) {
        let route = "/api/thirdGames/lowerScore"
        let requestData = {
            "flag": flag
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    chargeTypelist (cbSuccess?, cbFail?) {
        let route = "/api/charge/chargeTypelist"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 新查询线下转账配置
    getNewConfigMoneyInOfficialTransfer (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getNewConfigMoneyInOfficialTransfer"
        let requestData = {
            "chargeConfigId": id,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 新版查询线上入款配置
    getNewConfigMoneyInOnline (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getNewConfigMoneyInOnline"
        let requestData = {
            "chargeConfigId": id,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 新查询线下扫码配置
    getNewConfigMoneyInSolidcode (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getNewConfigMoneyInSolidcode"
        let requestData = {
            "chargeConfigId": id,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 查询特殊充值渠道
    getConfigMoneyInVip (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getNewConfigMoneyInVip"
        let requestData = {
            "chargeConfigId": id,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 查询usdt充值渠道
    getNewConfigMoneyInUSDT (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getConfigMoneyInUsdt"
        let requestData = {
            "chargeConfigId": id,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取最新的一条usdt订单
    getLatestUsdtOrder (cbSuccess?, cbFail?) {
        let route = "/api/charge/getLatestUsdtOrder"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 取消最新的那条订单
    cancelLatestUsdtOrder (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/cancelLatestUsdtOrder" + this.getParamsStr({orderId: id})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 查询usdt充值渠道
    getUsdtDecimals (cbSuccess?, cbFail?) {
        let route = "/api/charge/getUsdtDecimals"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 创建usdt订单
    createUSDTOrder (data, cbSuccess?, cbFail?) {
        let route = "/api/charge/createUsdtOrder"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 创建usdt订单
    submitUSDTOrder (data, cbSuccess?, cbFail?) {
        let route = "/api/charge/subbmitUsdtOrderInfo"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取usdt配置信息
    getUsdtInfoConfig (cbSuccess?, cbFail?) {
        let route = "/api/charge/getUsdtInfoConfig"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取银商充值优惠比例
    getYinshangDiscountConfig (cbSuccess?, cbFail?) {
        let route = "/api/charge/getYinshangDiscountConfig"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 在线充值
    chargeByOnLine (chargeMoney, id, cbSuccess?, cbFail?) {
        let route = "/api/charge/chargeByOnLine2"
        let requestData = {
            "chargeMoney": chargeMoney,
            "id": id
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 线下转账申请审核
    chargeByUnderLine (data, cbSuccess?, cbFail?) {
        let route = "/api/charge/chargeByUnderLine"
        let requestData = {
            "bankAddress": data.bankAddress,
            "bankName": data.bankName,
            "cardNo": data.cardNo,
            "cardPeopleName": data.cardPeopleName,
            "chargeMoney": data.chargeMoney,
            "chargeTypeId": data.chargeTypeId,
            "id": data.id,
            "remark": data.remark,
            "userBankAddress": data.userBankAddress,
            "userBankName": data.userBankName,
            "userBankTransferType": data.userBankTransferType,
            "userCardNo": data.userCardNo,
            "userCardPeopleName": data.userCardPeopleName,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 线下扫码转账申请审核
    chargeByUnderLineSolidcode (data, cbSuccess?, cbFail?) {
        let route = "/api/charge/chargeByUnderLineSolidcode"
        let requestData = {
            "chargeMoney": data.chargeMoney,
            "chargeTypeId": data.chargeTypeId,
            "id": data.id,
            "remark": data.remark,
            "userCardNo": data.userCardNo,
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 充值记录
    getRecord (pageNum, pageSize, cbSuccess?, cbFail?) {
        let route = "/api/charge/getRecord" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }



    //充值教程
    rechargeCourseList (data,cbSuccess?, cbFail?) {
        let route = "/api/rechargeCourse/list"
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    // 充值记录详情
    getRecordDetail (id, cbSuccess?, cbFail?) {
        let route = "/api/charge/getRecordDetail"
        let requestData = {
            "id": id
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 客服配置表分页查询
    customServiceList (cbSuccess?, cbFail?) {
        let route = "/api/customService/list"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取邮件数量
    receiveMessageCount (cbSuccess?, cbFail?) {
        let route = "/api/notice/receiveMessageCount"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 用户的收件箱
    receiveMessage (pageNum, pageSize, cbSuccess?, cbFail?) {
        let route = "/api/notice/receiveMessage" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 消息已读设置
    noticeReaded (id, cbSuccess?, cbFail?) {
        let route = "/api/notice/readed"
        let requestData = {
            "id": id
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 全部消息已读设置
    noticeAllReaded (cbSuccess?, cbFail?) {
        let route = "/api/notice/allReaded"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 消息删除设置
    noticeDel (id, cbSuccess?, cbFail?) {
        let route = "/api/notice/del"
        let requestData = {
            "id": id
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 删除全部消息
    noticeDelAll (cbSuccess?, cbFail?) {
        let route = "/api/notice/delAll"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 邮件领取奖励
    noticeReceiveAward (id, cbSuccess?, cbFail?) {
        let route = "/api/notice/receiveAward"
        let requestData = {
            "id": id
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 领取所有邮件的奖励
    noticeReceiveAwardAll (cbSuccess?, cbFail?) {
        let route = "/api/notice/receiveAwardAll"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    //洗码------------------------------------------------------------------------------------
    ximaInfo (cbSuccess?, cbFail?) {
        let route = "/api/wash/info";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    ximaGameList(cbSuccess?, cbFail?){
        let route = "/api/wash/gameList";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    ximaMaualWashCode(cbSuccess?, cbFail?){
        let route = "/api/wash/maualWashCode";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    ximaRecord(cbSuccess?, cbFail?){
        let route = "/api/wash/record";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    ximaWashCodeDetail(data,cbSuccess?, cbFail?){
        let route = "/api/wash/washCodeDeatil";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    ximaVippercentset(data,cbSuccess?, cbFail?){
        let route = "/return/washcode/vippercentset/listForGameType";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }
    //vip--------------------------------------------------------------------------------------
    vipShow(cbSuccess?, cbFail?){
        let route = "/api/userVip/info";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail)
    }

    vipReceivReword(data, cbSuccess, cbFail){
        let route = "/api/userVip/receivReword";
        this.gameServerHttpRequest(route,"POST",data, cbSuccess, cbFail)
    }

    // 签到------------------------------------------
    signInSignGet(data, cbSuccess, cbFail){//签到活动记录查询
        let route = "/activity/signrecord/get";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail ,true);
    }

    signInSign(data, cbSuccess, cbFail){//签到
        let route = "/activity/signrecord/sign";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail ,true);
    }

    signGetSignSwitch(data, cbSuccess, cbFail){//签到
        let route = "/activity/signrecord/getSignSwitch";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail ,true);
    }



    //绑定微信------------------------------------------------------------------------
    bindWeChatInfo(data,cbSuccess?, cbFail?){//是否绑定微信查询
        let route = "/api/wetchat/info";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    bindWeChat(data,cbSuccess?, cbFail?){//绑定微信
        let route = "/api/wetchat/bind";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    wechatNotice (data, cbSuccess?, cbFail?) {
        let route = "/api/wetchat/notice"
        this.gameServerHttpRequest(route, 'GET', data, cbSuccess, cbFail)
    }

    //代理-----------------------------------------------------------------------------
    agentInfo(cbSuccess?, cbFail?){//代理首页数据
        let route = "/api/retrun/brokerag/newInfo";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail);
    }

    agentGetAgentRecruitment(cbSuccess?, cbFail?){//代理招募
        let route = "/api/retrun/brokerag/getAgentRecruitment";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail);
    }



    agentReceivReword(data, cbSuccess, cbFail) {//分享领取奖励；
        let route = "/api/retrun/brokerag/receivReword";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentNewReceivReword(data, cbSuccess, cbFail){//返佣领取奖励
        let route = "/api/retrun/brokerag/newReceivReword";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    //领取明细
    agentShareDetail(data,pageNum,pageSize, cbSuccess, cbFail){//分享领取记录
        let route = "/api/retrun/brokerag/shareDeatial" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize});
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentReturnReceiveInfo(data,pageNum,pageSize, cbSuccess, cbFail){//返佣领取记录
        let route = "/api/retrun/brokerag/returnReceiveInfo" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize});
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentSubordinateInfo(data,pageNum,pageSize, cbSuccess, cbFail){//直属查询
        let route = "/api/retrun/brokerag/subordinateInfo" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize});
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentSubordinateRecordInfo(data, cbSuccess, cbFail){//直属详情查询
        let route = "/api/retrun/brokerag/subordinateRecordInfo" ;
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentPerformance(data,pageNum,pageSize, cbSuccess, cbFail){//直属业绩查询
        let route = "/api/retrun/brokerag/performance"+ this.getParamsStr({pageNum: pageNum, pageSize: pageSize});
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentGameDetail(data,pageNum,pageSize, cbSuccess, cbFail){//直属业绩详情查询
        let route = "/api/retrun/brokerag/performance/gameDetail" + this.getParamsStr({pageNum: pageNum, pageSize: pageSize});
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentDayGameReturnInfoTotal(data, cbSuccess, cbFail){//直属业绩详情查询
        let route = "/api/retrun/brokerag/dayGameReturnInfoTotal";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentGetGameCategoryAndGamePlatform(data, cbSuccess, cbFail){//直属业绩详情查询
        let route = "/api/retrun/brokerag/getGameCategoryAndGamePlatform";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentApplicationReward(data, cbSuccess, cbFail){//提交submit
        let route = "/api/retrun/brokerag/applicationReward";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentGeneralize(data, cbSuccess, cbFail){//推广教程
        let route = "/api/retrun/brokerag/generalize";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);

    }

    getQrcodeImage(cbSuccess?, cbFail?) {//获取二维码图片
        let route = "/api/home/qrcodeModel";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail);
    }

    getQrcodeImage2(cbSuccess?, cbFail?) {//获取二维码图片（未国际化）
        let route = "/api/retrun/brokerag/info";
        this.gameServerHttpRequest(route, 'POST', {}, cbSuccess, cbFail);
    }

    agentGetRanking(data, cbSuccess, cbFail){//财富榜
        let route = "/api/retrun/brokerag/getRanking";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentReturnConfig(data, cbSuccess, cbFail){//返佣比例
        let route = "/api/retrun/brokerag/returnConfig";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    agentshareTask(data, cbSuccess, cbFail){//获取分享任务
        let route = "/api/retrun/brokerag/shareTask";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    // 开户行列表
    bankList (type, cbSuccess?, cbFail?) {
        let route = "/api/user/bankList" + this.getParamsStr({type: type})
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }
	
	// 获取提现列表
    getAllPaymentByUser (cbSuccess?, cbFail?) {
        let route = "/api/user/getAllPaymentByUser"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取提现列表
    getWithdrawList (pageNum, pageSize, dataType, cbSuccess?, cbFail?) {
        let route = "/api/withdrawCash/list"
        let requestData = {
            page_no: pageNum,
            page_size: pageSize,
            data_type: dataType
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 绑定银行卡
    bindBank (data, cbSuccess?, cbFail?) {
        let route = "/api/user/bindBank"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 提现
    applyPaymentout (data, cbSuccess?, cbFail?) {
        let route = "/api/paymentout/applyPaymentout"
        let requestData = data
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取玩家投注明细
    findUserRecord (startTime, endTime, gameType, platform, cbSuccess?, cbFail?) {
        let route = "/api/gameRecord/findUserRecord"
        let requestData = {
            "end_time": endTime,
            "game_type": gameType,
            "page_no": 1,
            "page_size": 1000,
            "start_time": startTime,
            "type": platform
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 根据模板ID查询游戏类别和游戏平台查询
    gameTypeList (cbSuccess?, cbFail?) {
        let route = "/api/home/gameTypeList"
        let requestData = {}
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 交易类型
    payTypeList (cbSuccess?, cbFail?) {
        let route = "/api/detailsFunds/coinType"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 账户明细
    balanceDetailsList (startTime, endTime, payType, cbSuccess?, cbFail?) {
        let route = "/api/detailsFunds/payDetails/list"
        let requestData = {
            "startTime": startTime,
            "endTime": endTime,
            "page_no": 1,
            "page_size": 1000,
            "type": payType
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 公告
    noticeList (cbSuccess?, cbFail?) {
        let route = "/api/home/noticeList"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 头像列表
    getListPhoto (cbSuccess?, cbFail?) {
        let route = "/api/user/getListPhoto"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 更新头像
    editUserImage (imageId, cbSuccess?, cbFail?) {
        let route = "/api/user/editUserImage"
        let requestData = {
            "imageId": imageId
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取提现范围
    getMoneyOutlimit (cbSuccess?, cbFail?) {
        let route = "/api/user/getNewMoneyOutlimit"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 更新提现密码
    setDrawingPassword (password, passwordConfirm, cbSuccess?, cbFail?) {
        let route = "/api/user/setDrawingPassword"
        let requestData = {
            "oldPassword": password,
            "drawingPwd": passwordConfirm
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 从服务器获取热更信息
    getHotUpdateInfo (data, cbSuccess?, cbFail?) {
        let route = "/api/app/upgrade/info"
        let requestData = {
            deviceType: data.devieceType,
            packageName: data.packageName,
            versionCode: data.versionCode
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取小数点
    getRandomDecimal(cbSuccess?, cbFail?){
        let route = "/api/charge/getRandom"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取修复信息
    getFixData (cbSuccess?, cbFail?) {
        let route = "/api/app/fix/list"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 登录云信
    addYinShangAccount (cbSuccess?, cbFail?) {
        let route = "/api/charge/addNewYinShangAccount"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取音乐列表
    getMusicConfig (cbSuccess?, cbFail?) {
        let route = "/musicapi/config/getMusicConfig"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取域名列表
    getPayDomainList (cbSuccess?, cbFail?) {
        let route = "/api/conf/getPayDomainList"
        let requestData = {
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    // 获取游戏模版id
    getTemplates (packages, cbSuccess?, cbFail?) {
        let route = "/api/gamebiddings/getTemplates"
        let requestData = {
            packages: packages
        }
        this.gameServerHttpRequest(route, 'POST', requestData, cbSuccess, cbFail)
    }

    //任务-------------------------------------------------------------------------
    // taskGetRedDot(data, cbSuccess, cbFail){
    //     let route = "/api/task/redDot";
    //     this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    // }
    taskAuditShare(data, cbSuccess, cbFail){
        let route = "/api/task/auditShare";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    taskList(data, cbSuccess, cbFail){
        let route = "/api/task/list";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    taskGetTypes(data, cbSuccess, cbFail){
        let route = "/api/task/getTypes";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    taskGetAward(data, cbSuccess, cbFail){
        let route = "/api/task/getAward";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    taskRecommend(data, cbSuccess, cbFail){
        let route = "/api/task/recommend";
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }
    taskSwitch(data,switchType, cbSuccess, cbFail){//main-任务总开关, pop推荐任务开关
        let route = `/api/task/${switchType}/switch`;
        this.gameServerHttpRequest(route, 'POST', data, cbSuccess, cbFail)
    }

    //活动-------------------------------------------------------------------------
    activityTypeList(data, cbSuccess, cbFail){
        let route = "/api/activity/typeList";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    activityRecommendActivity(data, cbSuccess, cbFail){
        let route =  "/api/activity/recommendActivityList";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    activityList(data, cbSuccess, cbFail){
        let route =  "/api/activity/list";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }
    activityApplyContentActivity(data, cbSuccess, cbFail){
        let route =  "/api/activity/applyContentActivity";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }
    activityApplyRuleActivity(data, cbSuccess, cbFail){
        let route =  "/api/activity/applyRuleActivity";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail);
    }

    activityGetActivityById(data, cbSuccess, cbFail){
        let route = "/api/activity/getActivityById";
        this.activityServerHttpRequest(route, 'POST', data, cbSuccess, cbFail ,true);
    }
}

export default new NetworkLogic()